import * as notify from "../../../../shared/notify";

const FILE_SIZE_LIMIT = 10000000; // 10Mb decimal limit
const ZIP_FILE_LIMIT = 50000000; // 50 Mb

const FILE_SIZE_LABEL = "10MBs";

const isValidSize = (size, type = '') => {
    if (type.includes('zip')) {
        return size < ZIP_FILE_LIMIT;
    }

    return size < FILE_SIZE_LIMIT;
};

// TODO: needs refactor
const isValid = (file, accepts) => {
    if (file) {
        const { size, name } = file;

        if (size > 0) {
            if (!validateFileType(file, accepts)) {
                return false;
            }

            if (!isValidSize(size, accepts)) {
                notify.error(`File ${name} may not exceed ${FILE_SIZE_LABEL} in size.`);

                return false;
            }

            return true;
        }

        notify.error(`The file must be a valid file.`);

        return false;
    }

    return false;
};

const isValidMultiple = (files, accepts) => {
    let validFiles = [];

    if (!files.length > 0) {
        return;
    }

    for (let i = 0; i < files.length; i++) {
        if (isValid(files[i], accepts)) {
            validFiles.push(files[i]);
        }
    }

    return validFiles;
};

const validateFileType = (file, accepts) => {
    if (!file || file.kind === "string") {
        notify.error("Improper file type");

        return false;
    }

    const fileExt = "." + file.name.split(".").pop().toLowerCase();

    if (accepts && !accepts.includes(file.type) && !accepts.includes(fileExt)) {
        notify.error(`File type not accepted (${file.type})`);

        return false;
    }

    return true;
};

export { isValid, isValidMultiple, validateFileType, FILE_SIZE_LABEL };
